export function getSentAtTimestamp(date: Date = new Date(Date.now())) {
  return date.toISOString().replace('T', ' ').replace('Z', '000');
}
